import EventEmitter from 'eventemitter3';
let global = {};
let emitter = new EventEmitter();

const alo7Plugin = {
  getGlobal(value: string) {
    return global[value];
  },
  eventEmitter: emitter,
};

export function setAlo7PluginGlobal(name: string, fn: any) {
  global[name] = fn;
}

function clearAlo7PluginGlobal() {
  global = {};
  emitter = new EventEmitter();
}

window['clearAlo7PluginGlobal'] = clearAlo7PluginGlobal;
window.alo7Plugin = alo7Plugin;
